var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_368)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 12.3676C31.1038 12.7757 30.1502 13.0436 29.1727 13.1621C30.1897 12.5381 30.9702 11.5484 31.3379 10.3698C30.3854 10.9477 29.3335 11.3681 28.2091 11.5934C27.3132 10.6128 26.0326 10.0001 24.6155 10.0001C21.898 10.0001 19.6936 12.2607 19.6936 15.0489C19.6936 15.4445 19.7358 15.8289 19.8204 16.1988C15.7282 15.9875 12.1006 13.9797 9.66874 10.9216C9.24499 11.6697 9.00236 12.5379 9.00236 13.4626C9.00236 15.2135 9.87161 16.7589 11.1929 17.6649C10.3872 17.6405 9.62636 17.4106 8.96167 17.0349V17.0967C8.96167 19.5436 10.6591 21.5849 12.913 22.0473C12.5005 22.1658 12.065 22.2251 11.6156 22.2251C11.3044 22.2254 10.9939 22.1954 10.6885 22.1354C11.3154 24.1406 13.1326 25.601 15.2879 25.6398C13.6031 26.9949 11.4789 27.8022 9.1728 27.8022C8.7753 27.8022 8.38249 27.7792 7.99792 27.7329C10.1772 29.1629 12.7664 29.9994 15.5457 29.9994C24.6039 29.9994 29.5552 22.307 29.5552 15.6346C29.5552 15.4164 29.5509 15.1983 29.5424 14.9802C30.505 14.2681 31.3405 13.3797 31.9983 12.3671",
    fill: "#00AAEC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial1);
export default __webpack_public_path__ + "static/media/Social-1.bc07154233e9b9efff36a8b8f0b7a1a6.svg";
export { ForwardRef as ReactComponent };